import CMSSubjectPage from "./CMSSubjectPage";

export default CMSSubjectPage;
